import { application } from './application'
import MenuController from './menu_controller'
import AdminSidebarController from './admin/sidebar_controller'
import AdminProfileMenuController from './admin/profile_menu_controller'
import MermaidController from './mermaid_controller'
import ResultSelectorController from './result_selector_controller'
import QuestionBuilderController from './question_builder_controller'
import ToggleController from './answer_guidance_toggle_controller'
import AssessmentNavigationController from './assessment_navigation_controller'
import VignetteBuilderController from './vignette_builder_controller'
import JurisdictionVignetteVariationBuilderController from './jurisdiction_vignette_variation_builder_controller'
import DropdownMenuController from './dropdown_menu_controller'
import CopyToClipboardController from './copy_to_clipboard_controller'
import CollapsibleController from './collapsible_controller'
import DemographicsController from './demographics_controller'
import AdminOutcomeFormController from './admin/outcome_form_controller'
import TimezoneController from './timezone_controller'
import AdminTabsController from './admin/tabs_controller'
import AdminDeletionConfirmationController from './admin/deletion_confirmation_controller'
import AdminAssessmentSelectorController from './admin/assessment_selector_controller'
import AdminAnalyticsFilterController from './admin/analytics_filter_controller'
import AdminAssessmentFilterController from './admin/assessment_filter_controller'
import ReliabilityTesterFormController from './reliability_tester_form_controller'
import LogoModalController from './logo_modal_controller'
import BackToTopController from './back_to_top_controller'
import SelectionController from './selection_controller'
import SortableController from './sortable_controller'
import ReorderToggleController from './reorder_toggle_controller'
import DropdownController from './dropdown_controller'
import FieldTestModalController from './field_test_modal_controller'
import ConditionalExplanationController from './conditional_explanation_controller'
import AdminVignetteSampleController from './admin/vignette_sample_controller'
import DismissController from './dismiss_controller'
import ComboboxController from './combobox_controller'
import VariationGroupController from './variation_group_controller'
import VariationPreviewController from './variation_preview_controller'
import TesterCopyEditorController from './tester_copy_editor_controller'
import FieldErrorsController from './field_errors_controller'

application.register('menu', MenuController)
application.register('admin--sidebar', AdminSidebarController)
application.register('admin--profile-menu', AdminProfileMenuController)
application.register('mermaid', MermaidController)
application.register('result-selector', ResultSelectorController)
application.register('question-builder', QuestionBuilderController)
application.register('answer-guidance-toggle', ToggleController)
application.register('assessment-navigation', AssessmentNavigationController)
application.register('vignette-builder', VignetteBuilderController)
application.register(
  'jurisdiction-vignette-variation-builder',
  JurisdictionVignetteVariationBuilderController
)
application.register('dropdown-menu', DropdownMenuController)
application.register('copy-to-clipboard', CopyToClipboardController)
application.register('collapsible', CollapsibleController)
application.register('demographics', DemographicsController)
application.register('admin--outcome-form', AdminOutcomeFormController)
application.register('timezone', TimezoneController)
application.register('admin--tabs', AdminTabsController)
application.register(
  'admin--deletion-confirmation',
  AdminDeletionConfirmationController
)
application.register(
  'admin--assessment-selector',
  AdminAssessmentSelectorController
)
application.register(
  'admin--analytics-filter',
  AdminAnalyticsFilterController
)
application.register(
  'admin--assessment-filter',
  AdminAssessmentFilterController
)
application.register('reliability-tester-form', ReliabilityTesterFormController)
application.register('logo-modal', LogoModalController)
application.register('back-to-top', BackToTopController)
application.register('selection', SelectionController)
application.register('sortable', SortableController)
application.register('reorder-toggle', ReorderToggleController)
application.register('dropdown', DropdownController)
application.register('field-test-modal', FieldTestModalController)
application.register('conditional-explanation', ConditionalExplanationController)
application.register('admin--vignette-sample', AdminVignetteSampleController)
application.register('dismiss', DismissController)
application.register('combobox', ComboboxController)
application.register('variation-group', VariationGroupController)
application.register('variation-preview', VariationPreviewController)
application.register('tester-copy-editor', TesterCopyEditorController)
application.register('field-errors', FieldErrorsController)
